import React, { Component } from 'react';
require('./about.css');

class FirstaboutSec extends Component {
    render() {
        return (
            <section className="container sectionBreak" id="AboutSection">
                <h1 className='text-center'>About Us</h1><br />
                <div className="row">
                    <div className='col-md-6'>
                        <p id="aboutDescription">
                            <b style={{ color: 'blue' }} >Tinqer Mission: </b><br />
                            We are here to help businesses increase customer satisfaction and acheive great results with the use of cutting-edge AI Solutions and Bot Application.
                        <br />
                            Use the power of AI to run a smarter business and create a meaningful customer experience.
                        {/*Figuring out the right way to market and gain more customers has always been difficult.
                        What is more difficult and of utmost importance is making sure your business is targeting the right group of people and making sure the customers feel satisfied & special.*/}                            </p>
                    </div>
                    <div className='col-md-6'>
                        <img id='aboutImage' src={this.props.pics.aboutGirlImage}
                            alt="officeWork" style={{ borderRadius: '10px' }}
                        />
                    </div>
                </div>
                <hr />
            </section>
        );
    }
}

export default FirstaboutSec;


// WEBPACK FOOTER //
// ./src/About/FirstaboutSec.js